import React from 'react';
import { Card, List } from 'antd';
import PropTypes from 'prop-types';
import './style.less';

const styles = {};

const index = ({
  title,
  extraContent,
  loading,
  paginationProps,
  dataSource,
  renderListItem,
  children,
}) => {
  return (
    <div className="standardList">
      <Card
        className={styles.listCard}
        bordered={false}
        title={title}
        style={{ marginTop: 24 }}
        bodyStyle={{ padding: '0 32px 40px 32px' }}
        extra={extraContent}
      >
        <List
          size="large"
          rowKey="id"
          loading={loading}
          pagination={paginationProps}
          dataSource={dataSource}
          renderItem={renderListItem}
          itemLayout="vertical"
        >
          {children}
        </List>
      </Card>
    </div>
  );
};

index.defaultProps = {
  title: '',
  extraContent: () => null,
  loading: false,
  paginationProps: false,
  dataSource: [],
  renderListItem: () => null,
};

index.propTypes = {
  title: PropTypes.node,
  extraContent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  paginationProps: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
    .isRequired,
  dataSource: PropTypes.array.isRequired,
  renderListItem: PropTypes.func.isRequired,
};

export default index;
